export function CTA() {
  return (
    <section id="agendar" className="py-0">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative bg-[#F5F1ED] min-h-[600px] lg:min-h-[800px] flex items-end p-12 lg:p-16">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/7aec8d3c9ddd770a8d8d80993b545915.jpg"
              alt="Detalhes Acolhedores"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          </div>
          <div className="relative z-10">
            <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-medium px-4 py-2 rounded-full mb-6">
              Dê o primeiro passo
            </span>
            <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Sua Jornada
              <br />
              de Transformação
              <br />
              Começa Aqui
            </h2>
          </div>
        </div>

        <div className="bg-white min-h-[600px] lg:min-h-[800px] flex flex-col justify-center items-center p-12 lg:p-16">
          <div className="max-w-xl mx-auto w-full text-center">
            <h3 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-8 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Não Deixe Seu
              <br />
              Cuidado Emocional
              <br />
              Para Depois
            </h3>
            <p className="text-lg text-[#6B6B6B] mb-12 leading-relaxed">
              Sua saúde mental merece atenção e cuidado. Cada dia é uma oportunidade para começar sua transformação. Não adie mais o que pode mudar sua vida hoje. Estou aqui para te acolher e te ajudar nessa jornada de autoconhecimento e bem-estar.
            </p>

            <a
              href="https://wa.me/5511941652251"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#7DD3C0] text-white px-12 py-5 rounded-full text-lg font-medium hover:bg-[#6BC4B0] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:scale-105"
            >
              Agende Agora
              <i className="ri-arrow-right-line text-xl"></i>
            </a>

            <p className="text-sm text-[#6B6B6B] mt-8">
              Atendimento presencial ou online • Segunda a sexta, 8h às 22h
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}